import React from 'react';
import {UrlInputElementClass} from 'types/documentTemplateElement';
import {ElementProps} from 'types/documentTemplateElement';
import TextInput from '../../inputs/TextInput';
import {buildLabel, checkError} from 'utils/elementUtils';
import {useIsDocumentElementDisabled} from '../../../hooks/useIsDocumentElementDisabled';

const UrlInputElementComponent: React.FC<
  ElementProps<UrlInputElementClass>
> = ({element, updateElement, mode}) => {
  const disabled = useIsDocumentElementDisabled(element, mode);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (mode === 'view') {
      const newUpdatedElement = new UrlInputElementClass({
        ...element,
        properties: {
          ...element.properties,
          value: e.target.value,
        },
      });
      updateElement(newUpdatedElement);
    }
    if (mode === 'admin') {
      const newUpdatedElement = new UrlInputElementClass({
        ...element,
        properties: {
          ...element.properties,
          value: e.target.value,
        },
      });
      updateElement(newUpdatedElement);
    }
    return;
  };

  let containerClass = 'w-full m-8';
  if (mode === 'view' || mode === 'preview' || mode === 'admin') {
    containerClass = element.properties.showLabel
      ? 'w-full mx-3 mb-2'
      : 'w-full mt-5 mx-3 mb-2';
  }

  return (
    <div className={containerClass}>
      <TextInput
        id={element.id}
        type="url"
        error={checkError(element, mode)}
        label={buildLabel(element)}
        value={element.properties?.value || ''}
        placeholder={'URL'}
        required={element.properties.required}
        onChange={handleChange}
        disabled={disabled}
      />
    </div>
  );
};

export default UrlInputElementComponent;
